import React, { FunctionComponent } from "react";
import theme from "../../../../theme";
import { FormElementProps } from "../helpers";
import { CustomElement } from "../styles";
import { CustomCheckbox } from "./styles";
import checkMark from "../../../../assets/checkmark.svg";
import indeterminate from "../../../../assets/indeterminate.svg";

const Checkbox: FunctionComponent<FormElementProps> = ({
    size,
    selected,
    determinate,
    color,
    backgroundColor,
    borderColor,
    hoverColor,
    onClick,
    disabled,
    className,
    title,
    customStyles,
    containerClassName
}) => (
    <CustomElement
        className={containerClassName}
        customStyles={customStyles}
        disabled={disabled}
        onClick={onClick}
    >
        <CustomCheckbox
            backgroundColor={backgroundColor}
            borderColor={borderColor}
            className={className}
            color={color}
            customStyles={customStyles}
            determinate={determinate}
            disabled={disabled}
            hoverColor={hoverColor}
            selected={selected}
            size={size}
            title={title}
        >
            {selected ? <img alt="checkbox" src={checkMark} /> : null}
            {determinate ? <img alt="checkbox" src={indeterminate} /> : null}
        </CustomCheckbox>
        <b className="checkbox-label">{title}</b>
    </CustomElement>
);

Checkbox.defaultProps = {
    backgroundColor: theme.colors.primary.main.backgroundColor,
    borderColor: theme.colors.primary.main.backgroundColor,
    customStyles: {
        disabledColor: "#BCBCBC",
        opacity: "0.5px",
        paddingLeft: "10px"
    },
    hoverColor: theme.colors.primary.main.backgroundColor,
    size: 18
};

export default Checkbox;
